import { useTranslation } from 'react-i18next'
import { PaginationBar } from '@structural-climbing/ui'

interface Props {
  /** The page on screen, from 1. */
  page: number
  pageSize: number
  /** How many items the whole list holds, across every page. */
  total: number
  onPageChange: (page: number) => void
  /** While a page loads: the bar stays put but ignores clicks. */
  isLoading?: boolean
  className?: string
}

/**
 * Page numbers under a list, with "1–20 of 312" beside them. Every paged list
 * in the gym app uses this one, so they all read and behave the same: picking
 * a page goes back to the top of the screen.
 */
export function ListPages({ page, pageSize, total, onPageChange, isLoading, className }: Props) {
  const { t } = useTranslation()
  return (
    <PaginationBar
      className={className ?? 'mt-4'}
      page={page}
      pageSize={pageSize}
      total={total}
      onPageChange={(next) => {
        onPageChange(next)
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }}
      isDisabled={isLoading}
      ariaLabel={t('common.pagesLabel')}
      rangeLabel={(first, last, count) => t('common.pageRange', { first, last, total: count })}
    />
  )
}
